import { ChatBubbleLeftIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedStaffNoteCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface StaffNoteCreatedEventProps {
  event: DiscriminatedStaffNoteCreatedEvent;
}

export const StaffNoteCreatedEvent: React.FC<StaffNoteCreatedEventProps> = ({
  event,
}) => {
  const content = event.payload.content || event.payload.staff_note?.content;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-100">
          <ChatBubbleLeftIcon className="h-4 w-4 text-gray-600" />
        </div>
      }
    />
  );

  const body = content && (
    <ActivityBody>
      <ActivityDescription className="italic">
        &ldquo;{content}&rdquo;
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Note Added"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
